import { Component, Input, OnInit, Type } from '@angular/core';
import { PopoverController } from '@ionic/angular';
import { AdminServiceService } from 'src/app/admin/service/admin-service.service';
import { UiService } from 'src/app/admin/service/ui.service';

@Component({
  selector: 'app-stats-order-detail',
  templateUrl: './stats-order-detail.component.html',
  styleUrls: ['./stats-order-detail.component.scss'],
})
export class StatsOrderDetailComponent implements OnInit {
  @Input() user: any = undefined;
  @Input() showStore: any = undefined;
  @Input() admin: any = undefined;
  public totalComms!: number;
  public sons: any = [];

  constructor(
    private popoverController: PopoverController,
    private adminSv: AdminServiceService,
    private uiSv: UiService
  ) { }

  calcPercent(sonRange: number, profit: any, dadRange: number): number{
    if (sonRange === 0) {
      profit = profit*0.10;
      this.totalComms = this.totalComms + profit;
      // console.log('this.totalComms :>> ', this.totalComms);
      return profit;
    } else if(sonRange === 1 && dadRange === 2){
      profit = profit*0.10;
      this.totalComms = this.totalComms + profit;
      // console.log('this.totalComms :>> ', this.totalComms);
      return profit;
    } else if(sonRange === 1 && dadRange !== 2){
      profit = profit*0.20;
      this.totalComms = this.totalComms + profit;
      // console.log('this.totalComms :>> ', this.totalComms);
      return profit;
    } else if(sonRange === 2 && dadRange === 3){
      profit = profit*0.10;
      this.totalComms = this.totalComms + profit;
      // console.log('this.totalComms :>> ', this.totalComms);
      return profit;
    } else {
      return 0;
    }
  }

  ngOnInit() {
    this.totalComms = 0;
    this.user.sonsInfo.forEach(element => {
      // console.log('element :>> ', element);
      const commis = this.calcPercent(element.range, this.user.affiliateProfit, this.user.range);
      this.sons.push({name: element.name ,comm: commis});
    });
    // console.log('this.sons :>> ', this.sons);
  }

  async close(liquided = false){
    await this.popoverController.dismiss(liquided);
  }

  async pay(){
    const body = {
      id: this.user.id
    };
    const res: any = await this.adminSv.post(body, 'userGain', 'settleBalance');
    if(res.status){
      await this.uiSv.showToast('Usuario liquidado con exito');
      this.close(true);
    }
  }
}
